import { IColumnsItem } from '@/components/custom-table/type.d';
import { IGetGoodsListRes } from '@/api/goods-service/type.d';
import { IFilters } from '@/core/plugins/filter';
import { GOOSD_SERVICE_GOODS_STATE_LIST } from '@/constant';

export const renderColumns = (
  handleDelItem: (ids: string[]) => void,
  filters: IFilters,
  canDelete: boolean,
): IColumnsItem<IGetGoodsListRes['list'][0]>[] => [
  {
    type: 'selection',
    width: '44',
  },
  {
    label: 'SPU编码',
    prop: 'commodityCode',
    width: '100',
  },
  {
    label: '商品名称',
    prop: 'productName',
    ellipsis: true,
  },
  {
    label: '供应商名称',
    prop: 'supplierName',
    ellipsis: true,
  },
  {
    label: '分类',
    prop: 'categoryName',
    width: '160',
  },
  {
    label: '是否启用',
    width: '80',
    render: row => <div>{row.enabled === '1' ? '是' : '否'}</div>,
  },
  {
    label: '状态',
    width: '100',
    render: row => (
      <div>{filters.getEnumLabel(GOOSD_SERVICE_GOODS_STATE_LIST, row.productState)}</div>
    ),
  },
  {
    label: '创建时间',
    width: '110',
    render: row => <div>{filters.formatTime(row.createdTime)}</div>,
  },
  {
    label: '操作',
    width: '100',
    align: 'center',
    fixed: 'right',
    render: row => (
      <div class="flex">
        {canDelete && <el-button
          size="default"
          type="danger"
          onClick={() => handleDelItem([row.spuId])}
        >
          删除
        </el-button>}
      </div>
    ),
  },
];
